import { DATE_PROFILE_URL } from '../../../shared-util/src/lib/profile-date.service';
import { financialConfirmationInterceptor } from 'shared-ui';
import { environment } from '../environments/environment';
import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import {
  APEX_THEME_STORAGE_KEY,
  ApexPrimeNgPreset,
  ApexThemeService,
} from 'shared-ui';

import { routes } from './app.routes';
import { isStaleChunkError, reloadForStaleChunk } from './core/stale-chunk/stale-chunk';
import { AuthExpiredInterceptor } from './core/interceptors/auth-expired.interceptor';
import { WithCredentialsInterceptor } from './core/interceptors/credentials.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: DATE_PROFILE_URL, useValue: `${environment.apiGatewayUrl}/api/v1/profile` },
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    { provide: APEX_THEME_STORAGE_KEY, useValue: 'apexPlatformAdminColorScheme' },
    provideAppInitializer(() => {
      inject(ApexThemeService);
    }),
    providePrimeNG({
      theme: {
        preset: ApexPrimeNgPreset,
        options: {
          // A bare attribute selector becomes `:root[data-theme='dark']`. With an element prefix PrimeNG emits
          // `html[...] :root`, which never matches, so none of its dark-mode tokens would apply.
          darkModeSelector: "[data-theme='dark']",
        },
      },
    }),
    provideRouter(
      routes,
      // The router catches lazy-load failures itself, so a stale tab after a deploy must be handled here: reload
      // straight to the page being opened instead of showing an error.
      withNavigationErrorHandler((error) => {
        if (typeof window !== 'undefined' && isStaleChunkError(error.error)) {
          reloadForStaleChunk(error.url);
        }
      }),
    ),
    provideClientHydration(withEventReplay()),
    { provide: HTTP_INTERCEPTORS, useClass: WithCredentialsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthExpiredInterceptor, multi: true },
    provideHttpClient(withFetch(), withInterceptors([financialConfirmationInterceptor(environment.apiGatewayUrl)]), withInterceptorsFromDi()),
  ],
};
